import React, { useState, useEffect } from "react";
import { Box, Button, Text } from "@chakra-ui/react";
import styl1 from "./parti.css";
import { useNavigate } from "react-router-dom";
import ReactLoading from "react-loading";
import axios from "axios";
import Filter from "./Filter";
import { useCookies } from "react-cookie";
import clickJoin from "./Assets/joinSound.mp3";
import API_URL from "../Api/auction-api";

function Participate() {
  const [isloading, setLoading] = useState(true);
  const [isloading2, setLoading2] = useState(true);
  const [userData, setUserData] = useState([]);
  const [gridView, setGridView] = useState(false);
  const [menCategory, setMenCategory] = useState(false);
  const [productCategory, setProductCategory] = useState("");
  const [searchProduct, setSearchProduct] = useState("");
  const [cookies, setCookie] = useCookies();
  const [selectedCard, setSelectedCard] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [typeProduct, setType] = useState(false);
  const [nameProduct, setProductName] = useState("");
  const [findName, setFindName] = useState([]);
  const [renderEffect,setrenderEffect]=useState("")
  // console.log(searchProduct,productCategory,"hdhdhhdd")
  const filters = [
    {
      id: "Product Category",
      name: "Product Category",
      options: [
        { value: "ALL", label: "ALL" },
        { value: "Electronics", label: "Electronics" },
        { value: "Arts and painting", label: "Arts and painting" },
        { value: "Fashion and Apparel", label: "Fashion and Apparel" },
        { value: "Home and Kitchen", label: "Home and Kitchen" },
        {
          value: "Beauty and Personal Care",
          label: "Beauty and Personal Care",
        },
        { value: "Books and Media", label: "Books and Media" },
        { value: "Sports and Fitness", label: "Sports and Fitness" },
        { value: "Toys and Games", label: "Toys and Games" },
        { value: "Health and Wellness", label: "Health and Wellness" },
        {
          value: "Automotive and Accessories",
          label: "Automotive and Accessories",
        },
        { value: "Baby and Maternity", label: "Baby and Maternity" },
        {
          value: "Furniture and Home Decor",
          label: "Furniture and Home Decor",
        },
        { value: "Jewelry and Watches", label: "Jewelry and Watches" },
        { value: "Pet Supplies", label: "Pet Supplies" },
        {
          value: "Tools and Home Improvement",
          label: "Tools and Home Improvement",
        },
      ],
    },
  ];

  const navigate = useNavigate();

  //  click sound 
  const playSound = () => {
    const sound = new Audio(clickJoin);
    sound.play();
  };


// Getting all approved register cards with some conditions
  const getApprovedData = async (prodName) => {
    console.log(prodName,"pname")

    
    try {
      if (!productCategory && !searchProduct) {   // both are false 
        setLoading2(true);
        console.log(productCategory, "ppppp");
        let res = await axios.get(`${API_URL}/getApproveduser`);
        setUserData(res.data);
        console.log(res.data, "getdata");
        setLoading2(false);
      } else if (productCategory === "ALL" && !searchProduct) {  // productCategory=="all" and searchProduct false
        setLoading2(true);
        console.log(productCategory, "all");
        let res = await axios.get(`${API_URL}/getApproveduser`);
        setUserData(res.data);
        console.log(res.data, "getdata");
        setLoading2(false);
      } else if (productCategory === "ALL" && searchProduct) {
        setLoading2(true);
        console.log(searchProduct, "all,ser");
        let res = await axios.get(
          `${API_URL}/getApproveduser?searchproduct=${searchProduct}`
        );
        setUserData(res.data);
        console.log(res.data, "searapi");
        setLoading2(false);
      } else if (productCategory && !searchProduct) {
        setLoading2(true);
        console.log(productCategory, "ssss");
        let res = await axios.get(
          `${API_URL}/getApproveduser?productcategory=${productCategory}`
        );
        setUserData(res.data);
        console.log(res.data);
        setLoading2(false);
        
      }  
      // else if(prodName){
      //   console.log(nameProduct,"name")
      //   setLoading2(true);
      //   let res = await axios.get(
      //     `${API_URL}/getApproveduser?productname=${prodName}`
      //   );
      //   setUserData(res.data);
      //   console.log(res.data);
      //   setLoading2(false);


      // } 
      else if (searchProduct && !productCategory) {
        setLoading2(true);
        console.log(searchProduct, "ssss");
        let res = await axios.get(
          `${API_URL}/getApproveduser?searchproduct=${searchProduct}`
        );
        setUserData(res.data);
        console.log(res.data, "searapi");
        setLoading2(false);
      } else if (
        (productCategory && searchProduct) ||
        productCategory === "ALL"
      ) {
        setLoading2(true);
        let res = await axios.get(
          `${API_URL}/getApproveduser?productcategory=${productCategory}&searchproduct=${searchProduct}`
        );
        setUserData(res.data);
        console.log(res.data);
        setLoading2(false);
      }
    
     
    } catch (error) {
      console.log(error);
    }
  };

// user search anything this function will execute and show type of product
  async function handleSearchByName(pName){
    console.log(pName,"pname")
    setLoading2(true);
    setSearchProduct(pName)
    setrenderEffect(pName)
    console.log(searchProduct,"ssspprro")
   
    await getApprovedData()
    setType("")
    setLoading2(false);
    

  }

  //  search input onchange function

  function handleSearchChange(e) {
    console.log("jee serach");
    setType(e.target.value.toLowerCase())
    setSearchProduct(e.target.value.toLowerCase());
    showName(e.target.value)
    // getApprovedData()
  }

  //  product category onchange function
  function handleProductCategory(e) {
    setProductCategory(e.target.value);
    //  setTimeout(()=>{
    //    console.log(productCategory,"prododode")
    //    getApprovedData()

    //  },2000)
  }
  //  console.log(productCategory,"pproductcate")
  console.log(searchProduct, "ssercproduct");

  //  set roomid,email to cookies
  function participateAuction(email, roomno) {
    console.log("email", email);
    setCookie("participateEmail", email);
    setCookie("roomNumber", roomno);
    // return <Navigate to="/looby"/>
    navigate("/lobby");
  }

  //  show search box suggestion product type
  async function showName(name){
    console.log("name",name)
    let payload={
      typeofproduct:name
    }
    try {
      let res=await axios.post(`${API_URL}/getsearchnames`,payload)
   setFindName(res.data)
      
      console.log(res.data,"serdata")
      
    } catch (error) {
      console.log(error)
      
    }

  }
  //  enter function
  function pressEnter(event){
    if (event.keyCode === 13) {
      getApprovedData("")

      
    }

  }

  useEffect(() => {
    // setTimeout(() => {
    //   setLoading(false);
    // }, 4000);
    getApprovedData();
  }, [productCategory,renderEffect]);

  function debugBase64(base64URL) {
    var win = window.open();
    win.document.write(
      '<iframe src="' +
        base64URL +
        '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
    );
  }
  let jj;

  return (
    <>
      <div>
        {" "}
        {/* <Filter /> */}
        <div className="mx-auto py-8 px-4 w-full max-w-7xl bg-white">
          <div className="relative">
            {/* :HEAD TITLE */}
            <div className="pb-10 sm:py-10 flex flex-col items-center border-b-2 border-gray-200 text-center">
              {/* ::Title */}
              <h1 className="text-3xl sm:text-4xl text-gray-700 font-extrabold">
                Welcome
              </h1>
              {/* ::Text */}
              <p className="mt-5 max-w-xl text-base text-gray-500 font-medium">
                Find products faster! Use the category selection to search by
                product category, and the search bar to search by product name.
              </p>
            </div>

            {/* :FILTERS CONTAINER */}
            <div className="py-5 sm:px-4 flex flex-col-reverse md:flex-row items-center justify-between">
              {/* ::Filter Select Input */}
              <div className="flex-shrink-0 mt-5 md:mt-0 max-w-sm sm:max-w-none w-full md:w-auto grid sm:grid-flow-col grid-cols-1 sm:auto-cols-fr gap-4">
                {filters.map((filter) => (
                  <div key={filter.id} className="col-span-1">
                    <label htmlFor={filter.id} className="sr-only">
                      {filter.name}
                    </label>
                    <select
                      name={filter.id}
                      id={filter.id}
                      defaultValue={filter.name}
                      className="form-select w-full rounded border border-gray-300 text-base text-gray-900 focus:border-blue-500 focus:ring-blue-500 py-2 px-4"
                      onChange={handleProductCategory}
                    >
                      <option value="" className="font-semibold">
                        {filter.name}
                      </option>
                      {filter.options.map((option) => (
                        <option value={option.value} key={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                ))}
              </div>

              <div className="flex-grow lg:ml-5 w-full flex items-center justify-around md:justify-between space-x-4">
                {/* ::View Grid */}
                <span className="inline-flex">
                  {/* :::grid view button */}
                  <button
                    className={`inline-flex justify-center items-center ${
                      gridView
                        ? "text-blue-500"
                        : "text-gray-400 hover:text-gray-600"
                    }`}
                    onClick={() => setGridView(true)}
                  >
                    {/* <ViewGridIcon className="w-8 h-8" /> */}
                  </button>
                  {/* ::list view button*/}
                  <button
                    className={`ml-2 inline-flex justify-center items-center ${
                      !gridView
                        ? "text-blue-500"
                        : "text-gray-400 hover:text-gray-600"
                    }`}
                    onClick={() => setGridView(false)}
                  >
                    {/* <ViewListIcon className="w-8 h-8" /> */}
                  </button>
                </span>
                {/* ::Search Bar */}
                <div className="flex items-center space-x-2">
                  <input
                    type="text"
                    placeholder="Search by Product Type..."
                    className="py-2 px-8 sm:w-auto border border-gray-300 rounded bg-gray-100 text-base text-gray-600 focus:outline-none focus:border-blue-500 focus:ring-blue-500"
                    onChange={handleSearchChange}
                    onKeyDown={pressEnter}
                    
                    
                  />
                  <button
                    className="text-gray-400 hover:text-gray-600 bg-blue-500 rounded-full p-2"
                    onClick={()=>getApprovedData("")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path d="M22 12l-20 12 7.289-12-7.289-12z" />
                    </svg>
                  </button>
                </div>

                
              </div>
            </div>
           
              {(findName.length>0 && typeProduct) &&<Box pt="10px" width={{lg:"230px",md:"250px"}}  ml={{xl:"950px",sm:"10px",md:"480px",lg:"400px"}} pb="10px"  boxShadow="rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px">
              {findName.length>0 && <h1  onClick={()=>handleSearchByName(findName[0].producttype)} style={{paddingLeft:"10px",cursor:"pointer",margin:"10px"}}>{findName[0].producttype}</h1>}
                </Box>}
                
          </div>
        </div>
        {/* <a href="https://malak-tel-auction.netlify.app/lobby.html" target="_blank" rel="noopener noreferrer"><Button >join auction</Button></a> */}
        {isloading2 ? (
          <div
            style={{
              marginBottom: "10px",
              height: "50vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "white",
            }}
          >
            <ReactLoading
              type={"cubes"}
              color={"black"}
              height={"10%"}
              width={"10%"}
            />
          </div>
        ) : (
          <>
            <div className="px-4 py-16 -mt-10 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
              {!isMenuOpen && (
                <div className="grid gap-8 lg:grid-cols-3 md:grid-cols-2 md:max-w-full sm:max-w-sm sm:mx-auto lg:max-w-full">
                  {userData &&
                    userData.map((user, index) => (
                      <div
                        key={index}
                        className="overflow-hidden transition-shadow duration-300 bg-white rounded shadow-xl border "
                        data-aos={index % 6 < 3 ? "fade-right" : "fade-left"}
                        data-aos-duration="600"
                        data-aos-once="true"
                      >
                        <img
                          src={user.productimage}
                          className="object-cover w-full h-64 transform duration-200 hover:scale-105 cursor-pointer"
                          alt="productimage"
                          label="Click for full view"
                          loading="lazy"
                          onClick={() => debugBase64(user.productimage)}
                        />

                        <div className="p-5">
                          <p className="mb-3 text-xs font-semibold tracking-wide uppercase">
                            <span
                              href="/"
                              className="transition-colors duration-200 text-blue-gray-900 hover:text-deep-purple-accent-700"
                              aria-label="Time"
                              title="Time"
                            >
                              Product Name-:
                            </span>
                            <span
                              href="/"
                              className="ml-1 transition-colors duration-200 text-blue-gray-900 hover:text-deep-purple-accent-700"
                              aria-label="Time"
                              title="Time"
                            >
                              {user.productname}
                            </span>
                            <br></br>
                            <div className="mt-2">
                              <span
                                href="/"
                                className=" transition-colors duration-200 text-blue-gray-900 hover:text-deep-purple-accent-700"
                                aria-label="Time"
                                title="Time"
                              >
                                Category-:
                              </span>
                              <span
                                href="/"
                                className=" ml-2 transition-colors duration-200 text-blue-gray-900 hover:text-deep-purple-accent-700"
                                aria-label="Time"
                                title="Time"
                              >
                                {user.productcategory}
                              </span>
                            </div>
                            <div className="mt-2">
                              <span
                                href="/"
                                className=" transition-colors duration-200 text-blue-gray-900 hover:text-deep-purple-accent-700"
                                aria-label="Time"
                                title="Time"
                              >
                                Product Type-:
                              </span>
                              <span
                                href="/"
                                className=" ml-2 transition-colors duration-200 text-blue-gray-900 hover:text-deep-purple-accent-700"
                                aria-label="Time"
                                title="Time"
                              >
                                {user.producttype}
                              </span>
                            </div>
                            <div className="mt-2">
                              <span
                                href="/"
                                className=" transition-colors duration-200 text-blue-gray-900 hover:text-deep-purple-accent-700"
                                aria-label="Time"
                                title="Time"
                              >
                                Initial Bid-:
                              </span>
                              <span
                                href="/"
                                className=" ml-2 transition-colors duration-200 text-blue-gray-900 hover:text-deep-purple-accent-700"
                                aria-label="Time"
                                title="Time"
                              >
                                {user.productinitialrate} $
                              </span>
                            </div>
                          </p>
                          <a
                            aria-label="Category"
                            title={user.productname}
                            className="inline-block mb-3 text-xl font-bold leading-5 transition-colors duration-200 hover:text-deep-purple-accent-700"
                          >
                            {user.name}
                          </a>
                          <p className="mb-2 text-gray-700">
                            {user.description.split(" ").slice(0, 40).join(" ")}
                            ...
                          </p>
                          <button
                            onClick={() => {
                              setIsMenuOpen(true);
                              setSelectedCard(index);
                            }}
                            aria-label=""
                            className="inline-flex items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800 relative text-lg hover:underline  hover:text-blue-500 hover:duration-300 cursor-pointer"
                          >
                            Read more
                          </button>
                        </div>
                      </div>
                    ))}
                </div>
              )}

              {isMenuOpen && (
                <section class="text-gray-600 body-font overflow-hidden -mt-14">
                  <div class="container px-5 py-24 mx-auto">
                    <div class="lg:w-4/5 mx-auto flex flex-wrap relative">
                      <img
                        alt="iamgeeb"
                        class=" -mt-14 lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded cursor-pointer"
                        src={userData[selectedCard].productimage}
                        onClick={() =>
                          debugBase64(userData[selectedCard].productimage)
                        }
                      />
                      <div class="lg:w-1/2 w-full lg:pl-[1.5rem] lg:py-6 mt-6 lg:mt-0">
                        <div
                          className="absolute -top-14
                         right-0 mt-2 mr-2 transition duration-300 ease-in-out hover:scale-110 "
                        >
                          <button
                            aria-label="Close Menu"
                            title="Close Menu"
                            class=" p-2  transition duration-200 rounded bg-red-500  hover:bg-red-600 focus:bg-gray-200 focus:outline-none focus:shadow-outline "
                            onClick={() => setIsMenuOpen(false)}
                          >
                            <svg class="w-7 text-gray-900" viewBox="0 0 24 24">
                              <path
                                fill="currentColor"
                                d="M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z"
                              />
                            </svg>
                          </button>
                        </div>
                        <h2 class="text-lg title-font text-gray-900 tracking-widest mb-2">
                          {userData[selectedCard].name}
                        </h2>

                        <h1 class="text-gray-900 text-3xl title-font font-medium mb-3 ">
                          {userData[selectedCard].productname}
                        </h1>
                        <h1 class="text-gray-900 text-xl title-font font-medium mb-3 mt-2 ">
                          {userData[selectedCard].productcategory}
                        </h1>
                        <div class="flex mb-4 mt-2">
                          <span class="flex flex-wrap gap-2  items-center">
                            <span class="text-gray-600 ">
                              {userData[selectedCard].phoneno}
                            </span>
                            <span class="flex ml-1 pl-3 py-2 border-l-2 border-gray-200 space-x-2s"></span>
                            <a
                              href={`mailto:${userData[selectedCard].email}`}
                              class="inline text-gray-600 lg:-ml-2 "
                            >
                              {userData[selectedCard].email}
                            </a>
                          </span>
                        </div>
                        <div class="flex mb-4 ">
                          <span class="flex items-center">
                            <span class="text-gray-600">
                              {userData[selectedCard].address}
                            </span>
                          </span>
                        </div>
                        <span class="text-gray-600 mb-5">
                          {userData[selectedCard].country}
                        </span>
                        <div className="flex mt-6 items-center pb-5 border-b-2 border-gray-100 mb-5 text-lg font-bold">
                          About product
                        </div>
                        <p class="leading-relaxed ">
                          {userData[selectedCard].description}.
                        </p>
                        <div className="font-bold mt-4">
                          Room ID-: {userData[selectedCard].roomno}
                        </div>
                        <div className="flex mt-6 items-center pb-5 border-b-2 border-gray-100 mb-5 text-lg font-bold">
                          Payment Method
                        </div>
                        {userData[selectedCard].paymentmethode === "PayPal" && (
                          <span className="mr-3 font-bold">
                            {userData[selectedCard].paymentmethode}
                          </span>
                        )}
                        {userData[selectedCard].paymentmethode ===
                          "cryptoTransfer" && (
                          <span className="mr-3 font-bold">
                            {userData[selectedCard].paymentmethode}
                          </span>
                        )}
                        {userData[selectedCard].paymentmethode ===
                          "cryptoTransferMAAT" && (
                          <span className="mr-3 font-bold">
                            {userData[selectedCard].paymentmethode}
                          </span>
                        )}
                        <div className="flex mt-6 items-center pb-5 border-b-2 border-gray-100 mb-5">
                          {userData[selectedCard].paymentmethode ===
                            "PayPal" && (
                            <div className="flex">
                              {/* Render PayPal specific information here */}
                              <span className="text-base">
                                {userData[selectedCard].paypalemail}
                              </span>
                            </div>
                          )}
                          {userData[selectedCard].paymentmethode ===
                            "cryptoTransfer" && (
                            <div className="flex flex-wrap">
                              {/* Render crypto transfer specific information here */}
                              <span className="text-sm">
                                {userData[selectedCard].blockchainnetwork}
                              </span>
                              <span className="flex ml-1 pl-1 py-2 border-l-2 border-gray-200 space-x-2s"></span>
                              <span className="text-sm">
                                {userData[selectedCard].blockchainaddress}
                              </span>
                            </div>
                          )}
                          {userData[selectedCard].paymentmethode ===
                            "cryptoTransferMAAT" && (
                            <div className="flex flex-wrap">
                              <span className="text-sm">Polygon Address</span>
                              <span className="flex ml-1 pl-1 py-2 border-l-2 border-gray-200 space-x-2s"></span>
                              <span className="text-sm">
                                {userData[selectedCard].polygonnetwork}
                              </span>
                              {/* Render Malak-tel specific information here */}
                              {/* Add any additional details specific to Malak-tel */}
                            </div>
                          )}
                        </div>
                        <div class="flex">
                          <span class="title-font font-medium text-2xl text-gray-900">
                            Initial bid{" "}
                            {userData[selectedCard].productinitialrate}$
                          </span>

                          <button
                            onClick={() =>
                              participateAuction(
                                userData[selectedCard].email,
                                userData[selectedCard].roomno
                              )
                            }
                            class="flex ml-auto py-2 px-2 font-medium tracking-wide text-white bg-green-500 rounded-md shadow-[0_4px_9px_-4px_#3b71ca] transition duration-200 ease-in-out  hover:shadow-green-600 uppercase"
                          >
                            Go to live Room
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Participate;
